import { PayoutService } from '../../services/payoutService';
import { createPageStore } from '../pageStore';

const payoutService = new PayoutService();

const fetchData = async (): Promise<Object> => {
  return await payoutService.getPayout();
};

export const useWalletPayoutStore = createPageStore(fetchData);
